import React from 'react';
import {Icon, message, Modal, Upload} from 'antd';
import config from '../utils/config'
import {findFile} from "../services/global";
import {getExtension, isImgFile, sha1File} from "../utils/sha1file";

class CkUploads extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            previewImage: null,
            previewVisible: false,
            fileList: this.props.value || [],
        }
    }


    componentWillReceiveProps(nextProps) {
        if( !nextProps.value || (nextProps.value && nextProps.value.length==0)){
            this.setState({
                fileList: []
            })
        }
    }


    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    onChange = (action) => {
       
        if (action.file.status === "done" && action.file.response.code === 500) {
            message.error(action.file.response.msg);
            action.fileList.pop();
        }

        this.setState({
            fileList: action.fileList.slice(-50)
        })

        const cval = action.fileList.map((f) => {
            return {
                url: f.url || (f.response && f.response.data),
                raw: f
            };
        })
        this.props.onChange(cval);
    }


    handlePreview = (file) => {
        console.log("file", file);
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    }

    beforUpload = (file, fileList) => {
        var that = this;
        return new Promise(function (resolve, reject) {
            sha1File(file, (fileSha1) => {
                const fileExtension = getExtension(file.name);
                const uploadFilename = fileExtension ? `${fileSha1}.${fileExtension}` : fileSha1;
                findFile(uploadFilename).then(res => {
                    if (res.code == 200 && res.data) {
                        if (isImgFile(file.name)) {
                            that.getBase64(file, thumbUrl => {
                                Object.assign(file, {
                                    status: "done",
                                    response: {
                                        data: res.data
                                    },
                                    thumbUrl: thumbUrl
                                })
                                that.onChange({
                                    file,
                                    fileList: [...that.state.fileList, file]
                                })
                                console.log("fileListfileList222", file, fileList)
                            })
                        }
                    } else {
                        resolve();
                    }
                }).catch(err => {
                    console.log(err);
                    err._statusCode == 600 ? message.warn("上传异常,网络似乎不正常!") : message.warn("上传异常");

                })
            })
        });
    }

    render() {
        return (
            <div className="clearfix">
                <Upload
                    headers= {{Authorization: `Bearer ${localStorage.getItem('token')}`}}
                    action={config.api.uploadFile}
                    listType="picture-card"
                    accept={this.props.accept}
                    multiple={true}
                    fileList={this.state.fileList}
                    withCredentials={true}
                    beforeUpload={this.beforUpload}
                    onPreview={this.handlePreview}
                    onChange={this.onChange}
                >
                    {
                        this.state.fileList.length >= 50 ? null :
                            <div>
                                <Icon type="upload"/>
                                <div className="ant-upload-text">上传</div>
                            </div>
                    }
                </Upload>

                <Modal
                    width="70%"
                    visible={this.state.previewVisible}
                    footer={null}
                    onCancel={() => {
                        this.setState({
                            previewVisible: false,
                        })
                    }}
                >
                    <img alt="example" style={{width: '100%'}} src={this.state.previewImage}/>
                </Modal>
            </div>
        )
    }
}

CkUploads.contextTypes = {}

CkUploads.defaultProps = {
    accept: "image/jpeg,image/png,image/jpg,image/gif",
    onChange: (fileUrls) => null,
}

CkUploads.propTypes = {}

export default CkUploads;


// WEBPACK FOOTER //
// ./src/components/CkUploads.jsx